import classNames from 'classnames';

import styles from './_index.module.scss';

export interface PopoverItemProps {
  icon?: React.ReactNode;
  isActive?: boolean;
}

export const PopoverItem = <T extends React.ElementType>({
  as,
  children,
  className,
  icon,
  isActive,
  ...props
}: PolymorphicProps<T> & PopoverItemProps) => {
  const Component = as || 'button';
  return (
    <Component
      className={classNames(styles['popover-item'], className, { [styles['is-active']]: isActive })}
      {...props}
    >
      {icon && (
        <div className={styles['popover-item-icon']} role="presentation">
          {icon}
        </div>
      )}
      <div>{children}</div>
    </Component>
  );
};

export default PopoverItem;
